<template>
  <div>
    <!-- 抽屉组件 -->
    <el-dialog
        :visible.sync="drawerVisible"
        :show-close="false"
        append-to-body
        width="60%"
    >
      <div class="diglog_h">
        <div>设备选择</div>
        <img src="@/assets/structure/close.png" class="diglog_icon" @click="drawerVisible = false"/>
      </div>
      <div class="device-body">
        <div class="body-content">
          <div class="content-left">
            <div class="left-header">
              <div style="width: 260px;">
                <el-radio-group v-model="queryFrom.type">
                  <el-radio-button v-for="(item,index) in typeList" :label="item.value" :key="index">{{item.label}}</el-radio-button>
                </el-radio-group>
              </div>
              <el-input v-if="queryFrom.type == 1"
                  v-model="queryFrom.name"
                  clearable
                  placeholder="搜索设备"
              >
                <i slot="suffix" style="font-size: 14px;cursor: pointer;" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="content check-disable">
              <div v-show="queryFrom.type == 1">
                <el-tree
                    ref="treeRef"
                    :data="deviceList"
                    show-checkbox
                    node-key="id"
                    @check-change="handleDeviceCheckChange"
                    class="device-tree"
                    :filter-node-method="filterNode"
                    @node-click="handleNodeClick"
                    :props="{children: 'children', label: 'name'}">
                  <template #default="{ node, data }">
                    <div class="custom-tree-node" @click.stop="handleRowClick(1,node, data)">
                      <svg t="1770450054725" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="70131" width="14" height="14"><path d="M692.224 121.694316c0.808421 3.718737 3.018105 4.904421 6.736842 3.718737l68.284632-2.15579c60.200421 0 107.088842 52.224 110.268631 115.765895l0.161684 6.898526v687.104h-73.62021V245.921684c0-26.516211-15.737263-46.403368-33.306947-48.828631l-3.503158-0.269474-68.284632 2.155789v681.391158c0 58.853053-46.565053 106.603789-103.962947 106.60379-5.443368 0-10.994526-0.431158-16.384-1.293474l-5.389474-1.077895-331.991579-37.402947c-46.295579-10.24-79.764211-51.038316-82.081684-99.166316l-0.053895-5.12V193.266526c0-48.559158 31.851789-90.758737 77.231158-103.154526l4.850526-1.185684L573.332211 51.469474c56.050526-12.341895 106.927158 12.665263 118.945684 70.224842zM539.486316 444.416a36.810105 36.810105 0 0 0-36.810105 36.810105v73.620211a36.810105 36.810105 0 0 0 73.62021 0V481.28a36.810105 36.810105 0 0 0-36.810105-36.810105z" fill="#707070" fill-opacity=".65" p-id="70132"></path></svg>
                      <span class="label">{{ data.name }}</span><span v-if="data.sn">（{{ data.sn }}）</span>
                    </div>
                  </template>
                </el-tree>
              </div>
              <div v-show="queryFrom.type == 2">
                <el-tree
                    ref="treeSpaceRef"
                    :data="visitorTypeList"
                    show-checkbox
                    node-key="id"
                    @check-change="handleSpaceCheckChange"
                    class="device-tree"
                    :render-after-expand="false"
                    @node-click="handleNodeClick"
                    :props="{children: 'deviceList', label: 'name'}">
                  <template #default="{ node, data }">
                    <div class="custom-tree-node" @click.stop="handleRowClick(2, node, data)">
                      <svg v-if="data.sn" t="1770450054725" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="70131" width="14" height="14"><path d="M692.224 121.694316c0.808421 3.718737 3.018105 4.904421 6.736842 3.718737l68.284632-2.15579c60.200421 0 107.088842 52.224 110.268631 115.765895l0.161684 6.898526v687.104h-73.62021V245.921684c0-26.516211-15.737263-46.403368-33.306947-48.828631l-3.503158-0.269474-68.284632 2.155789v681.391158c0 58.853053-46.565053 106.603789-103.962947 106.60379-5.443368 0-10.994526-0.431158-16.384-1.293474l-5.389474-1.077895-331.991579-37.402947c-46.295579-10.24-79.764211-51.038316-82.081684-99.166316l-0.053895-5.12V193.266526c0-48.559158 31.851789-90.758737 77.231158-103.154526l4.850526-1.185684L573.332211 51.469474c56.050526-12.341895 106.927158 12.665263 118.945684 70.224842zM539.486316 444.416a36.810105 36.810105 0 0 0-36.810105 36.810105v73.620211a36.810105 36.810105 0 0 0 73.62021 0V481.28a36.810105 36.810105 0 0 0-36.810105-36.810105z" fill="#707070" fill-opacity=".65" p-id="70132"></path></svg>
                      <svg v-else t="1770452277311" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="73012" width="14" height="14"><path d="M862.208 953.088H163.072c-28.672 0-55.808-11.264-76.032-31.488-20.224-20.48-31.488-47.36-31.488-76.288l1.536-668.928c0.256-59.136 48.384-107.264 107.52-107.264h192c49.408 0 95.232 28.672 116.992 72.96l60.928 123.904c3.84 7.68 11.776 12.8 20.48 12.8h289.024c69.376 0 125.696 56.32 125.696 125.696v441.344c0 59.136-48.128 107.264-107.52 107.264zM164.608 130.304c-25.344 0-46.08 20.736-46.08 46.08l-1.536 668.928c0 12.288 4.864 23.808 13.568 32.768 8.704 8.704 20.224 13.568 32.512 13.568h699.136c25.344 0 46.08-20.736 46.08-46.08V404.224c0-35.584-28.928-64.256-64.256-64.256H555.008c-32 0-61.696-18.432-75.776-47.104L418.56 168.96c-11.52-23.296-35.84-38.4-61.696-38.4H164.608z" fill="#707070" p-id="73013"></path><path d="M848.896 330.24c-16.896 0-30.72-13.824-30.72-30.72V242.432c0-25.344-20.736-46.08-46.08-46.08H461.824c-16.896 0-30.72-13.824-30.72-30.72s13.824-30.72 30.72-30.72h310.528c59.392 0 107.52 48.128 107.52 107.52V299.52c-0.256 16.896-13.824 30.72-30.976 30.72zM611.072 745.472h-368.64c-16.896 0-30.72-13.824-30.72-30.72s13.824-30.72 30.72-30.72h368.64c16.896 0 30.72 13.824 30.72 30.72s-13.568 30.72-30.72 30.72z" fill="#707070" p-id="73014"></path></svg>
                      <span class="label">{{ data.name }}</span><span v-if="data.sn">（{{ data.sn }}）</span>
                      <span v-if="!data.sn" style="color: gray;margin-left: 5px;">({{data.deviceList?.length || 0}})</span>
                    </div>
                  </template>
                </el-tree>
              </div>
            </div>
            <div class="left-bottom">
              <el-checkbox v-show="queryFrom.type===1" v-model="queryFrom.isAllDevicesSelected" @change="handleSelectAllDevice">全选<span style="margin-left: 5px;">共（{{deviceList.length}}个设备）</span></el-checkbox>
              <el-checkbox v-show="queryFrom.type===2" v-model="queryFrom.isAllSpacesSelected" @change="handleSelectAllSpace">全选</el-checkbox>
            </div>
          </div>
          <div class="content-right">
            <div class="content">
              <div class="content-title">
                <div>已选中（{{selectedDeviceList.length}}个设备）</div>
                <div class="deleteAll" @click="handleDeleteAll">清空</div>
              </div>
              <div class="content-body">
                <div class="content-item" v-for="item in selectedDeviceList" :key="item.id">
                  <div class="content-item-text">
                    <svg t="1770450054725" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="70131" width="14" height="14"><path d="M692.224 121.694316c0.808421 3.718737 3.018105 4.904421 6.736842 3.718737l68.284632-2.15579c60.200421 0 107.088842 52.224 110.268631 115.765895l0.161684 6.898526v687.104h-73.62021V245.921684c0-26.516211-15.737263-46.403368-33.306947-48.828631l-3.503158-0.269474-68.284632 2.155789v681.391158c0 58.853053-46.565053 106.603789-103.962947 106.60379-5.443368 0-10.994526-0.431158-16.384-1.293474l-5.389474-1.077895-331.991579-37.402947c-46.295579-10.24-79.764211-51.038316-82.081684-99.166316l-0.053895-5.12V193.266526c0-48.559158 31.851789-90.758737 77.231158-103.154526l4.850526-1.185684L573.332211 51.469474c56.050526-12.341895 106.927158 12.665263 118.945684 70.224842zM539.486316 444.416a36.810105 36.810105 0 0 0-36.810105 36.810105v73.620211a36.810105 36.810105 0 0 0 73.62021 0V481.28a36.810105 36.810105 0 0 0-36.810105-36.810105z" fill="#707070" fill-opacity=".65" p-id="70132"></path></svg>
                    <span>{{item.name}}</span><span v-if="item.sn">（{{ item.sn }}）</span>
                  </div>
                  <div>
                    <i class="el-icon-error" style="font-size: 14px;color:gray;cursor: pointer;" @click="handleDelete(item)"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="available_frame_bto">
        <div class="available_frame_cancel" @click="handleCancel">取消</div>
        <el-button class="available_frame_comfin" @click="handleConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {VisitorTypeApi} from "@/api/server/visitorType";
import {DmsDeviceApi} from "@/api/server/dmsDevice";

export default {
  name: 'DeviceSelectDialog',
  props: {
  },
  data() {
    return {
      queryFrom:{
        type: 1,
        isAllDevicesSelected: false,
        isAllSpacesSelected: false,
      },
      drawerVisible: false,
      typeList:[
        {value: 1, label: '设备'},
        {value: 2, label: '访客类型'},
      ],
      selectedDeviceList: [],
      deviceList: [],
      visitorTypeList: []
    };
  },
  computed: {},
  watch: {
    'queryFrom.name': function (val) {
      this.$refs.treeRef.filter(val);
    }
  },
  methods: {
    async show(list) {
      this.drawerVisible = true;
      if(!this.local){
        await this.getVisitorTypeList();
        await this.getDeviceList();
      }
      this.selectedDeviceList = list || [];
      this.$nextTick(() => {
        this.$refs.treeRef?.setCheckedKeys([]);
        this.$refs.treeSpaceRef?.setCheckedKeys([]);
        this.selectedDeviceList.forEach(row => {
          this.$refs.treeRef?.setChecked(row.id, true,true);
          this.$refs.treeSpaceRef?.setChecked(row.id, true,true);
        })
      })
    },
    async getDeviceList(){
      const params = {
        allowVisitor: true,
        equipmentUsageTypeList: [2,3]
      }
      const response = await DmsDeviceApi.queryDmsDeviceList(params);
      if (response.code == 200) {
        this.deviceList = response.data;
      }
    },
    async getVisitorTypeList(){
      const response = await VisitorTypeApi.getVisitorTypeList({});
      if (response.code == 200) {
        this.visitorTypeList = response.data;
      }
    },

    handleSelectAllDevice(){
      const tree =  this.$refs.treeRef;
      if(this.queryFrom.isAllDevicesSelected){
        tree.setCheckedKeys(this.deviceList.map(item => item.id));
      }else{
        tree.setCheckedKeys([]);
      }
    },
    handleSelectAllSpace(){
      const tree = this.$refs.treeSpaceRef;
      if(this.queryFrom.isAllSpacesSelected){
        tree.setCheckedKeys(this.visitorTypeList.map(item => item.id));
      }else{
        tree.setCheckedKeys([]);
      }
    },
    handleDeviceCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
      if(checked){
        if(!this.selectedDeviceList.find( d => d.id == data.id)){
          this.selectedDeviceList.push(data);
          this.$refs.treeSpaceRef?.setChecked(data.id, true,true);
        }
      }else{
        this.selectedDeviceList = this.selectedDeviceList.filter((d) => d.id !== data.id);
        this.$refs.treeSpaceRef?.setChecked(data.id, false,true);
      }
    },
    handleSpaceCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
      if(checked){
        if(!this.selectedDeviceList.find( d => d.id == data.id) && data.sn){
          this.selectedDeviceList.push(data);
          this.$refs.treeRef?.setChecked(data.id, true,true);
        }
      }else{
        this.selectedDeviceList = this.selectedDeviceList.filter((d) => d.id !== data.id);
        this.$refs.treeRef?.setChecked(data.id, false,true);
      }
    },
    handleDelete(row){
      this.selectedDeviceList = this.selectedDeviceList.filter((d) => d.id !== row.id);
      this.$refs.treeRef?.setChecked(row.id, false,true);
      this.$refs.treeSpaceRef?.setChecked(row.id, false,true);
    },
    handleDeleteAll(){
      this.selectedDeviceList = [];
      this.$refs.treeRef?.setCheckedKeys([]);
      this.$refs.treeSpaceRef?.setCheckedKeys([]);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1 || data.sn.indexOf(value) !== -1;
    },
    handleNodeClick (data, node) {
      // 这里可以处理节点点击的其他逻辑
      console.log('节点点击:', data, node)
    },
    handleRowClick (type,node, data) {
      // 切换节点的勾选状态
      if(type==1){
        this.$refs.treeRef.setChecked(node.key, !node.checked, true)
      }else{
        this.$refs.treeSpaceRef.setChecked(node.key, !node.checked, true)
      }
      // 如果需要同时勾选子节点
      // toggleChildren(node, node.checked)
    },
    // 取消按钮
    handleCancel() {
      this.drawerVisible = false;
      this.$emit('cancel');
    },
    // 确定按钮
    handleConfirm() {
      this.$emit('confirm', this.selectedDeviceList);
      this.drawerVisible = false;
    },
  },
};
</script>

<style scoped>
.device-body{
  padding: 10px;
}
.body-content {
  display: flex;
  height: 50vh;
  border: 1px solid #d8d9de;
  border-radius: 4px;
}
.body-content .content-left .left-header{
  display: flex;
  align-items: center;
  padding: 12px;
}
.body-content .content-left {
  border-right: 1px solid #d8d9de;
  flex-grow: 1;
  position: relative;
}
.body-content .content-left .content{
  height: calc(100% - 6.5rem);
  overflow: auto;
}
.body-content .content-left .left-bottom{
  padding: 10px 25px;
}
.content-body{
  padding: 10px;
  padding-right: 20px;
  overflow-y: auto;
  height: calc(100% - 4.5rem);
}
.content-body .content-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
}
.content-body .content-item .content-item-text{
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 0.9375rem;
  color: #1f2329;
  text-overflow: ellipsis;
  font-weight: 500;
}
.content-body .content-item .content-item-text .icon{
  margin-right: 10px;
}
.custom-tree-node{
  font-size: 0.9375rem;
  color: #1f2329;
  text-overflow: ellipsis;
  font-weight: 500;
  position: relative;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  cursor: pointer;
}
::v-deep .device-tree .el-tree-node .el-tree-node__content{
  padding: 5px 0!important;
}
::v-deep .device-tree .el-tree-node .el-tree-node__children{
  margin-left: 20px;
}
.custom-tree-node .label{
  margin-left: 8px;
}
.body-content .content-right {
  padding-left: 12px;
  position: relative;
  width: 50%;
  min-width: 50%;
}
.body-content .content-right .content-title{
  padding: 12px;
  font-size: 0.9375rem;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.body-content .content-right .content-title .deleteAll{
  color: #3172f6;
  position: absolute;
  right: 20px;
  top: 16px;
  cursor: pointer;
  height: 32px;
  font-size: 14px;
  font-weight: 400;
}
.body-content .content-right .content{
  height: 100%;
}
.block-checkbox {
  display: block;
  margin-bottom: 8px; /* 可选：添加间距 */
  font-size: 14px;
  color: #1f2329;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  padding: 8px 15px;
}
.diglog_h {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  padding: 24px;
  border-bottom: 1px solid #cfd4e8;
  color: #1a1a1a;
}

.diglog_icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.available_frame_bto {
  display: flex;
  align-items: center;
  justify-content: center;
}

.available_frame_cancel {
  width: 100px;
  height: 40px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #d5d7e3;
  font-size: 15px;
  color: #7e84a3;
  margin-right: 30px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.available_frame_comfin {
  width: 100px;
  height: 40px;
  background: #0058ff;
  border-radius: 4px 4px 4px 4px;
  font-size: 15px;
  color: white;
  text-align: center;
  cursor: pointer;
}
</style>